import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LOGO_WHITE from "../assets/img/logos/logo_white.png";
import { THEME } from "../common/const";
import { useWallletContext } from "../hook/useWalletContext";
import { getSimpleAddress } from "../common/helper";
import Jazzicon, { jsNumberForAddress } from "react-jazzicon";

export const Header = () => {
  const { currentAddress, disconnect, theme, handleTheme } =
    useWallletContext();

  const [sideMenuToggled, setSideMenuToggled] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState<boolean>(false);

  useEffect(() => {
    if (sideMenuToggled) {
      document.documentElement.setAttribute(
        "data-toggled",
        "icon-overlay-close"
      );
    } else {
      document.documentElement.removeAttribute("data-toggled");
    }
  }, [sideMenuToggled]);

  const toggleSidebar = () => {
    setSideMenuToggled(!sideMenuToggled);
  };

  const ToggleDark = (theme: string) => {
    handleTheme(theme);
  };

  let [i, seti] = useState(true);

  const Fullscreen = (vale: any) => {
    let elem: any = document.documentElement;

    switch (vale) {
      case true:
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Safari */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE11 */
          elem.msRequestFullscreen();
        }
        seti(false);
        break;
      case false:
        document.exitFullscreen();
        seti(true);
        break;
    }
  };

  useEffect(() => {
    const navbar = document.querySelector(".header") as HTMLElement;
    const navbar1 = document.querySelector(".app-sidebar") as HTMLElement;
    const sticky = navbar.clientHeight;
    // const sticky1 = navbar1.clientHeight;

    function stickyFn() {
      if (window.pageYOffset >= sticky) {
        navbar.classList.add("sticky-pin");
        navbar1.classList.add("sticky-pin");
      } else {
        navbar.classList.remove("sticky-pin");
        navbar1.classList.remove("sticky-pin");
      }
    }

    window.addEventListener("scroll", stickyFn);
    window.addEventListener("DOMContentLoaded", stickyFn);

    // Cleanup event listeners when the component unmounts
    return () => {
      window.removeEventListener("scroll", stickyFn);
      window.removeEventListener("DOMContentLoaded", stickyFn);
    };
  }, []);

  return (
    <Fragment>
      <header className="header custom-sticky !top-0 !w-full">
        <nav className="main-header" aria-label="Global">
          <div className="header-content">
            <div className="header-left">
              <div className="">
                <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={() => toggleSidebar()}
                >
                  <span className="sr-only">Toggle Navigation</span>
                  <i className="ri-arrow-right-circle-line header-icon"></i>
                </button>
              </div>
            </div>

            <div className="responsive-logo">
              <Link
                className="responsive-logo-dark"
                to={`/dashboard`}
                aria-label="Brand"
              >
                <img src={LOGO_WHITE} alt="logo" className="mx-auto" />
              </Link>
              <Link
                className="responsive-logo-light"
                to={`/dashboard`}
                aria-label="Brand"
              >
                <img src={LOGO_WHITE} alt="logo1" className="mx-auto" />
              </Link>
            </div>

            <div className="header-right">
              <div className="responsive-headernav">
                <div className="header-nav-right">
                  <div
                    className="header-theme-mode hidden sm:block"
                    onClick={() =>
                      ToggleDark(
                        theme === THEME.DARK ? THEME.LIGHT : THEME.DARK
                      )
                    }
                  >
                    <Link
                      aria-label="anchor"
                      className="hs-dark-mode-active:hidden flex hs-dark-mode group flex-shrink-0 justify-center items-center gap-2 h-[2.375rem] w-[2.375rem] rounded-full font-medium bg-gray-100 hover:bg-gray-200 text-gray-500 align-middle focus:outline-none focus:ring-0 focus:ring-gray-400 focus:ring-offset-0 focus:ring-offset-white transition-all text-xs dark:bg-bgdark dark:hover:bg-black/20 dark:text-white/70 dark:hover:text-white dark:focus:ring-white/10 dark:focus:ring-offset-white/10"
                      to="#"
                      data-hs-theme-click-value="dark"
                    >
                      <i className="ri-moon-line header-icon"></i>
                    </Link>
                    <Link
                      aria-label="anchor"
                      className="hs-dark-mode-active:flex hidden hs-dark-mode group flex-shrink-0 justify-center items-center gap-2 h-[2.375rem] w-[2.375rem] rounded-full font-medium bg-gray-100 hover:bg-gray-200 text-gray-500 align-middle focus:outline-none focus:ring-0 focus:ring-gray-400 focus:ring-offset-0 focus:ring-offset-white transition-all text-xs dark:bg-bgdark dark:hover:bg-black/20 dark:text-white/70 dark:hover:text-white dark:focus:ring-white/10 dark:focus:ring-offset-white/10"
                      to="#"
                      data-hs-theme-click-value="light"
                    >
                      <i className="ri-sun-line header-icon"></i>
                    </Link>
                  </div>
                  <div
                    className="header-fullscreen hidden lg:block"
                    onClick={() => Fullscreen(i)}
                  >
                    <Link
                      aria-label="anchor"
                      to="#"
                      className="inline-flex flex-shrink-0 justify-center items-center gap-2 h-[2.375rem] w-[2.375rem] rounded-full font-medium bg-gray-100 hover:bg-gray-200 text-gray-500 align-middle focus:outline-none focus:ring-0 focus:ring-gray-400 focus:ring-offset-0 focus:ring-offset-white transition-all text-xs dark:bg-bgdark dark:hover:bg-black/20 dark:text-white/70 dark:hover:text-white dark:focus:ring-white/10 dark:focus:ring-offset-white/10"
                    >
                      <i className="ri-fullscreen-line header-icon full-screen-open"></i>
                      <i className="ri-fullscreen-line header-icon fullscreen-exit-line hidden"></i>
                    </Link>
                  </div>
                  <div
                    className={`header-profile hs-dropdown ti-dropdown ml-3 ${
                      showMenu ? "open" : ""
                    }`}
                    data-hs-dropdown-placement="bottom-right"
                  >
                    <button
                      id="dropdown-profile"
                      type="button"
                      className="hs-dropdown-toggle ti-dropdown-toggle gap-2 p-0 flex-shrink-0 h-8 w-8 rounded-full border-0 shadow-none focus:ring-gray-400 text-xs dark:focus:ring-white/10"
                      onClick={() => setShowMenu(!showMenu)}
                    >
                      <Jazzicon
                        diameter={32}
                        seed={jsNumberForAddress(currentAddress ?? "")}
                      />
                    </button>

                    <div
                      className="hs-dropdown-menu ti-dropdown-menu border-0 w-[20rem]"
                      aria-labelledby="dropdown-profile"
                    >
                      <div className="ti-dropdown-header !bg-primary flex">
                        <div className="ltr:mr-3 rtl:ml-3">
                          <Jazzicon
                            diameter={32}
                            seed={jsNumberForAddress(currentAddress ?? "")}
                          />
                        </div>
                        <div className="flex">
                          <p className="ti-dropdown-header-content !text-white/50 my-auto">
                            {getSimpleAddress(currentAddress ?? "", 10)}
                          </p>
                        </div>
                      </div>
                      <div className="mt-2 ti-dropdown-divider">
                        <Link to={`/dashboard/`} className="ti-dropdown-item">
                          <i className="ti ti-home text-lg"></i>
                          Dashboard
                        </Link>
                        <Link to={`/setting/`} className="ti-dropdown-item">
                          <i className="ti ti-settings text-lg"></i>
                          Settings
                        </Link>
                        <Link
                          to="#"
                          className="ti-dropdown-item"
                          onClick={disconnect}
                        >
                          <i className="ti ti-logout  text-lg"></i>
                          Disconnect
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </Fragment>
  );
};
